import React from "react";
import ReactDOM from "react-dom/client";
import "./assets/css/index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { ApolloProvider } from "@apollo/client";
import { GoogleOAuthProvider } from "@react-oauth/google";
import client from "./config/client";
import GoogleAuth from "./components/Integrations/GoogleCalendarIntegration";
import { PayPalScriptProvider } from "@paypal/react-paypal-js";
const initialOptions = {
  "client-id":
    "Ae_ItuXBsqihwVmzn88xzotgqDNCi5KeizD6vtkHkU3J1dO7xHCydx8KW1-27DlvUB41u1W91eHpyAtR",
  currency: "USD",
  intent: "capture",
};
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <ApolloProvider client={client}>
    <GoogleOAuthProvider clientId="687565690470-llp5rs1pb8osd45v35vl6tj5gc44ahk3.apps.googleusercontent.com">
      <BrowserRouter>
        <React.StrictMode>
          <PayPalScriptProvider options={initialOptions}>
            <App />
          </PayPalScriptProvider>
        </React.StrictMode>
      </BrowserRouter>
    </GoogleOAuthProvider>
  </ApolloProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
